module.exports = __webpack_public_path__ + "img/light-logo.d380b0c0.png";